package com.artvending.warden

import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.number
import kotlin.text.padStart


class DateTimeUserData(
	val dateStr: String,
	val timeStr: String,
	val late: Int?,
	val fixedTime: TimeInterval?,
	val timelineUnits: List<TimelineUnit>
) {
	companion object {
		fun get(): DateTimeUserData {
			val currentDateTime = LocalDateTime.now()
			val dayOfWeek = getDayOfWeekStr(currentDateTime.dayOfWeek)
			val day = currentDateTime.dayOfMonth
			val month = getMonthStr2(currentDateTime.month.number)
			val hours = currentDateTime.hour
			val minutes = currentDateTime.minute
			val hoursStr = hours.toString()
			val minutesStr = minutes.toString().padStart(2, '0')
			val late = if (todayWorkingTime?.from == null) null else (fixedInterval?.from ?: (hours * 60 + minutes)) - (todayWorkingTime?.from ?: 0)
			val timelineUnits = TimelineUnit.createUnits(currentDateTime)
			
			return DateTimeUserData("$dayOfWeek. $day $month", "$hoursStr:$minutesStr", late, fixedInterval, timelineUnits)
		}
	}
}